import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { AccountLockingInfo } from '../../types/generated/Account.schema';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetAccountLockQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
}>;


export type GetAccountLockQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, delinquentAt?: string | null, managedBy?: Types.AccountManagementTypes | null, tier?: Types.AccountTier | null, unpaidAt?: string | null, lockedAt?: string | null, lockReason?: Types.LockReason | null, owner?: { __typename?: 'Owner', id: string, name: string, email: string } | null } | null };

export type AccountLockFragment = { __typename?: 'Account', id: string, delinquentAt?: string | null, managedBy?: Types.AccountManagementTypes | null, tier?: Types.AccountTier | null, unpaidAt?: string | null, lockedAt?: string | null, lockReason?: Types.LockReason | null, owner?: { __typename?: 'Owner', id: string, name: string, email: string } | null };

export const AccountLock = /*#__PURE__*/ gql`
    fragment AccountLock on Account {
  ...AccountLockingInfo
  id
  delinquentAt
  managedBy
  owner {
    id
    name
    email
  }
  tier
  unpaidAt
}
    ${AccountLockingInfo}` as unknown as DocumentNode<AccountLockFragment, unknown>;
export const GetAccountLock = /*#__PURE__*/ gql`
    query GetAccountLock($accountId: ID!) {
  account(accountId: $accountId) {
    ...AccountLock
  }
}
    ${AccountLock}` as unknown as DocumentNode<GetAccountLockQuery, GetAccountLockQueryVariables>;

        

        
export const useAccountLockFragment = (
  input: string | Omit<UseFragmentOptions<AccountLockFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Account' } };
    return input;
  })();

  return useFragment<AccountLockFragment>({
    fragment: AccountLock,
    fragmentName: 'AccountLock',
    ...options,
  });
};
  
        
          

          export const useGetAccountLockQuery = (options?:QueryHookOptions<GetAccountLockQuery, GetAccountLockQueryVariables>) => useQuery(GetAccountLock, options);

          

          export type GetAccountLockQueryOptions = QueryHookOptions<GetAccountLockQuery, GetAccountLockQueryVariables>;

          

          export const useGetAccountLockLazyQuery = (options?:LazyQueryHookOptions<GetAccountLockQuery, GetAccountLockQueryVariables>) => useLazyQuery(GetAccountLock, options);

          

          export type GetAccountLockQueryResult = ReturnType<typeof useGetAccountLockQuery>;

          
